import { z } from 'zod';
import { zOptId, zOptText, zText } from './common';

export const pageSchema = z.object({
  slug: z.string().trim().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Solo minúsculas, números y guiones').max(80),
  title: zText(160),
  body: zOptText(100000),
  campusId: zOptId,
  isPublished: z.boolean().default(false),
  sortOrder: z.number().int().min(0).max(999).default(0),
});
